import { SET_PERMISSIONS, CLEAR_PERMISSIONS } from "../types/permissions.types";

const initialState = {
  navData: [],
  permissionMap: {}
};

const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PERMISSIONS: {
      const menus = action.payload || [];

      const map = {};

      menus.forEach((m) => {
        if (m.children && m.children.length > 0) {
          m.children.forEach((c) => {
            const childKey = (c.content || "").toLowerCase();
            if (!childKey) return;
            map[childKey] = {};
            (c.access || []).forEach((a) => {
              map[childKey][a.name] = a.status;
            });
          });
        } else {
          const key = (m.content || "").toLowerCase();
          if (!key) return;
          map[key] = {};
          (m.access || []).forEach((a) => {
            map[key][a.name] = a.status;
          });
        }
      });

      return {
        ...state,
        navData: menus,
        permissionMap: map
      };
    }

    case CLEAR_PERMISSIONS:
      return initialState;

    default:
      return state;
  }
};

export default permissionsReducer;
